import { useQuery } from "@tanstack/react-query";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import ApiService from "../../services/ApiService";
import { PA_VALUE_DRIVERS } from "../keys";

const usePAValueDrivers = ({ rightsholderId = 0, parentTenantId = null, groupBy = 'event' } = {}) => {
  const tenant = useSelector((state) => state.auth.tenant);
  const date = useSelector((state) => state.date);
  const { startDate, endDate } = date;
  const enabled = !!(startDate && endDate);

  let since, until;
  if (enabled) {
    since = format(new Date(startDate), "yyyy-MM-dd");
    until = format(new Date(endDate), "yyyy-MM-dd");
  }

  return useQuery({
    queryKey: [PA_VALUE_DRIVERS, tenant.id, rightsholderId, parentTenantId, groupBy, startDate, endDate],
    queryFn: () => ApiService.getPlacementAnalysisValueDrivers({
      rightsholderId,
      parentTenantId,
      group_by: groupBy,
      since,
      until,
    }),
    select: (data) => data.data,
    enabled,
    placeholderData: { data: { groups: [], total: 0 } },
  });
};

export default usePAValueDrivers;
